import React from "react"
export function KuwaitFlag(props) {
  return (
    <svg viewBox="0 0 24 16" {...props}>
      <g
        id="prefix__Kuwait"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g id="prefix__kuwait" fillRule="nonzero">
          <path
            id="prefix__Rectangle"
            stroke="#CCC"
            strokeWidth={0.5}
            fill="#FFF"
            d="M4.25 4.956h19.5v6.088H4.25z"
          />
          <path id="prefix__Rectangle" fill="#4C8056" d="M0 0h24v5.647H0z" />
          <path id="prefix__Rectangle" fill="#C03A2B" d="M0 10.353h24V16H0z" />
          <path id="prefix__Path" fill="#2C2F38" d="M0 0l7 5.647v4.706L0 16z" />
        </g>
      </g>
    </svg>
  )
}
